import { CanvasApiBaseResponse } from '../../common/requestsTypings';
import { SharedData } from '../../common/typings';
import { CanvasIdea, IdeasSource } from '../../IdeasList/typings';
import { CanvasApiMethodExecutor } from '../CanvasApiMethodExecutor';

export interface FetchIdeasApiResponse extends CanvasApiBaseResponse {
    ideaId: string;
    url: string;
    name: string;
    items: CanvasIdea[];
}

export class IdeasMethodExecutor extends CanvasApiMethodExecutor {
    async fetchIdeasCreatives(source: IdeasSource, sharedData?: SharedData): Promise<FetchIdeasApiResponse> {
        let path;
        let params;

        if (source.ideaId) {
            path = `ideas/${source.ideaId}`;
            params = {
                method: 'GET'
            };
        } else {
            path = 'ideas';
            params = {
                method: 'POST',
                body: JSON.stringify({ url: source.url })
            };
        }

        return await this.createRequest<FetchIdeasApiResponse>(path, params, sharedData);
    }
}
